"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemTitleDiv = exports.MenuItemTitleClamp = exports.MenuItemIcon = exports.MenuItemContainer = exports.MenuItemArrowIndicator = exports.MenuItemArrowClickAreaInner = exports.MenuItemArrowClickArea = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Clamp = _interopRequireDefault(require("../../../../components/Clamp"));
var _Chevron = _interopRequireDefault(require("./icons/Chevron"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MenuItemArrowIndicator = exports.MenuItemArrowIndicator = (0, _styledComponents.default)(_Chevron.default).withConfig({
  displayName: "styles__MenuItemArrowIndicator",
  componentId: "sc-krro8j-0"
})(["fill:", ";opacity:0.65;width:", ";height:", ";", ""], ({
  theme
}) => theme.colors.appFrame.menu.itemArrowIndicator, ({
  theme
}) => theme.AppFrame.menu.itemArrow.width, ({
  theme
}) => theme.AppFrame.menu.itemArrow.height, ({
  $expandable,
  $open,
  $closable
}) => $expandable && (0, _styledComponents.css)(["transition:transform .3s ease-in-out;transform:", ";opacity:", ";"], $open ? 'rotate(-90deg)' : 'rotate(90deg)', $closable ? '0.65' : '0.2'));
const MenuItemIcon = exports.MenuItemIcon = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuItemIcon",
  componentId: "sc-krro8j-1"
})(["position:relative;display:flex;align-items:center;justify-content:center;width:", ";height:", ";line-height:", ";flex-shrink:0;opacity:", ";margin:", ";& img{width:32px;height:32px;}"], ({
  theme
}) => theme.AppFrame.menu.itemIcon.width, ({
  theme
}) => theme.AppFrame.menu.itemContainer.height, ({
  theme
}) => theme.AppFrame.menu.itemIcon.lineHeight, ({
  theme
}) => theme.AppFrame.menu.itemIcon.opacity, ({
  theme
}) => theme.AppFrame.menu.itemIcon.margin);
const menuItemTitleStyles = (0, _styledComponents.css)(["color:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";letter-spacing:", ";padding-right:15px;opacity:", ";transition:opacity 0.3s ease-in-out;overflow-wrap:anywhere;", ";"], ({
  theme
}) => theme.colors.appFrame.menu.itemText, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.AppFrame.menu.itemTitle.fontSize, ({
  theme,
  isOpen
}) => isOpen ? theme.AppFrame.menu.itemTitle.fontWeightBold : theme.AppFrame.menu.itemTitle.fontWeight, ({
  theme
}) => theme.AppFrame.menu.itemTitle.lineHeight, ({
  theme
}) => theme.AppFrame.menu.itemTitle.letterSpacing, ({
  theme
}) => theme.AppFrame.menu.itemTitle.opacity, ({
  $collapsed
}) => $collapsed && (0, _styledComponents.css)(["opacity:0;"]));
const MenuItemTitleClamp = exports.MenuItemTitleClamp = (0, _styledComponents.default)(_Clamp.default).withConfig({
  displayName: "styles__MenuItemTitleClamp",
  componentId: "sc-krro8j-2"
})(["", ""], menuItemTitleStyles);
const MenuItemTitleDiv = exports.MenuItemTitleDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuItemTitleDiv",
  componentId: "sc-krro8j-3"
})(["", ""], menuItemTitleStyles);
const MenuItemArrowClickArea = exports.MenuItemArrowClickArea = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuItemArrowClickArea",
  componentId: "sc-krro8j-4"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;right:0;position:absolute;width:", ";height:", ";padding:8px 0;"], ({
  theme
}) => theme.AppFrame.menu.itemArrowContainer.width, ({
  theme
}) => theme.AppFrame.menu.itemArrowContainer.height);
const MenuItemArrowClickAreaInner = exports.MenuItemArrowClickAreaInner = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuItemArrowClickAreaInner",
  componentId: "sc-krro8j-5"
})(["border-left:", ";display:flex;flex-direction:row;align-items:center;justify-content:center;height:100%;width:100%;"], ({
  theme
}) => theme.AppFrame.menu.itemArrowContainer.border);
const getPaddingLeftForExpandableNode = (defaultPaddingLeft = '0px', pxToShift) => `calc(${defaultPaddingLeft} + ${pxToShift}px)`;
const menuItemContainerExpandableStyles = ({
  $collapsed,
  level,
  isPartOfActivePath,
  theme
}) => (0, _styledComponents.css)(["", " ", " ", ""], level >= 3 && `padding-left: ${getPaddingLeftForExpandableNode(theme.AppFrame.menu.itemContainer.paddingLeft, 10 * (level - 2))} !important;`, level === 2 && theme.name === 'mds' && !$collapsed && `padding-left: ${theme.AppFrame.menu.itemContainer.paddingLeft} !important;`, isPartOfActivePath && `background-color: ${theme.colors.appFrame.menu.groupBg};`);
const MenuItemContainer = exports.MenuItemContainer = _styledComponents.default.a.withConfig({
  displayName: "styles__MenuItemContainer",
  componentId: "sc-krro8j-6"
})(["", ";position:relative;width:", ";min-height:", ";height:auto;padding:", ";display:flex;flex-direction:row;align-items:center;", ";", ";&:active,&:hover{", ",", "{color:", ";", ";", ";}", "{", ";}", "{", ";}}&:hover{background-color:", ";", ";}&:active{&:before{bottom:auto;top:50%;transform:translateY(-50%);position:absolute;content:'';width:4px;height:", ";background-color:", ";left:0;}}", ";", ";"], ({
  isExpandable,
  ...rest
}) => isExpandable && menuItemContainerExpandableStyles(rest), ({
  theme
}) => theme.AppFrame.menu.itemContainer.width, ({
  theme
}) => theme.AppFrame.menu.itemContainer.height, ({
  theme
}) => theme.AppFrame.menu.itemContainer.padding, ({
  $collapsed,
  theme
}) => $collapsed && theme.name === 'mds' && (0, _styledComponents.css)(["padding:", ";"], theme.AppFrame.menu.itemContainer.collapsedPadding), ({
  submenuItem,
  theme
}) => theme.name !== 'mds' && (submenuItem ? `
    height: auto;
    padding: 16px;
  ` : `
    ${MenuItemTitleDiv},
    ${MenuItemTitleClamp} {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  `), MenuItemTitleDiv, MenuItemTitleClamp, ({
  theme
}) => theme.colors.appFrame.menu.itemTextHover, ({
  theme
}) => theme.AppFrame.menu.itemTitle.hover, ({
  $collapsed
}) => $collapsed && (0, _styledComponents.css)(["opacity:0;"]), MenuItemIcon, ({
  theme
}) => theme.AppFrame.menu.itemTitle.hover, MenuItemArrowIndicator, ({
  theme
}) => theme.AppFrame.menu.itemTitle.hover, ({
  theme
}) => theme.colors.appFrame.menu.itemHoverBg, ({
  theme,
  active
}) => theme.name === 'mds' && active && (0, _styledComponents.css)(["background-color:", ";"], theme.colors.appFrame.menu.itemActiveBg), ({
  theme
}) => theme.AppFrame.menu.itemContainer.badgeHeight, ({
  theme
}) => theme.colors.appFrame.menu.itemActiveBadge, ({
  active,
  $collapsed,
  theme
}) => active && (0, _styledComponents.css)(["", ";", ",", "{", ";", ";", ";}", "{", ";}", "{", ";}&:before{bottom:auto;top:50%;transform:translateY(-50%);position:absolute;content:'';width:4px;height:", ";background-color:", ";left:0;}"], theme.name === 'mds' && (0, _styledComponents.css)(["background-color:", ";"], theme.colors.appFrame.menu.itemActiveBg), MenuItemTitleDiv, MenuItemTitleClamp, theme.AppFrame.menu.itemTitle.hover, $collapsed && (0, _styledComponents.css)(["opacity:0;"]), theme.name === 'mds' && (0, _styledComponents.css)(["font-weight:500;"]), MenuItemIcon, theme.AppFrame.menu.itemTitle.hover, MenuItemArrowIndicator, theme.AppFrame.menu.itemTitle.hover, theme.AppFrame.menu.itemContainer.badgeHeight, theme.colors.appFrame.menu.itemActiveBadge), ({
  hasArrowIndicator
}) => hasArrowIndicator && (0, _styledComponents.css)(["", ",", "{padding-right:50px;}"], MenuItemTitleDiv, MenuItemTitleClamp));